import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import ChannelPartnerAdmin from './pages/ChannelPartnerAdmin';
import Login from './pages/Login';
import Dashboard from './layouts/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { EnquiryCountsProvider } from './context/EnquiryContext';

function AdminPage() {
  return <EnquiryCountsProvider><div className="App"><Dashboard><ChannelPartnerAdmin /></Dashboard></div></EnquiryCountsProvider>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
